import { render, staticRenderFns } from "./SelfMentorshipModules.vue?vue&type=template&id=6b035135&scoped=true"
import script from "./SelfMentorshipModules.vue?vue&type=script&lang=js"
export * from "./SelfMentorshipModules.vue?vue&type=script&lang=js"
import style0 from "./SelfMentorshipModules.vue?vue&type=style&index=0&id=6b035135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b035135",
  null
  
)

export default component.exports